import ClickAwayListener from "react-click-away-listener";
import { useState, cloneElement, useEffect } from "react";
import { MdArrowDownward, MdArrowDropDown, MdAdd } from "react-icons/md";

export function Select({
  value,
  children,
  onChange,
  style,
  className,
  onAdd,
  addText,
}) {
  const [open, setOpen] = useState(false);
  const [_value, setValue] = useState();

  const handleSelect = (v) => {
    setOpen(false);
    onChange(v);
  };

  useEffect(() => {
    try {
      const display = children.find((x) => x.props.value === value);
      setValue(display.props.children);
    } catch (err) {
      setValue("");
    }
  }, [children, value]);

  return (
    <div
      onClick={() => setOpen(true)}
      style={{ ...style }}
      className={"select " + className}
    >
      <div style={{ flexGrow: 1 }}>{_value}</div>
      <MdArrowDropDown style={{ fontSize: 16 }} />
      {open && (
        <ClickAwayListener
          mouseEvent={"mouseup"}
          onClickAway={() => setOpen(false)}
        >
          <div
            style={{
              position: "absolute",
              top: 29,
              left: 0,
              right: 0,
              backgroundColor: "white",
              border: "1px solid var(--main-border-color)",
              maxWidth: 200,
              boxShadow: "0px 2px 10px 0px rgba(0,0,0,.15)",
              zIndex: 300,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {children.map((Child) => {
              return cloneElement(Child, {
                key: Child.props.value,
                onClick: handleSelect,
                className: "option",
              });
            })}
            {onAdd && (
              <div
                className={"option"}
                style={{
                  borderTop: "1px solid #E0E0E0",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={onAdd}
              >
                <MdAdd style={{ marginRight: 4 }} /> {addText}
              </div>
            )}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
}

export function Option({ value, children, onClick, className }) {
  return (
    <div className={className} onClick={() => onClick(value)}>
      {children}
    </div>
  );
}
